// extracted by mini-css-extract-plugin
export var planCard = "_vp-0";
export var planList = "_vp-1";